module.exports = __webpack_public_path__ + "img/news_center_img3.b8adb11a.jpg";